import GifSearch from './GifSearch.container';

export default GifSearch;
